import { objectModule } from "@/modules/object";
import type {
  DesktopAudioArtifactMetadata,
  DesktopAudioCaptureDiagnosticsContext,
  RecallPermissionMap,
} from "./types";

export const getDesktopAudioCaptureDiagnosticsContext = ({
  metadata,
}: {
  metadata?: DesktopAudioArtifactMetadata;
}): DesktopAudioCaptureDiagnosticsContext => {
  if (!metadata) {
    return {};
  }

  return normalizeDesktopAudioCaptureDiagnosticsContext({
    captureDiagnosticsContext: {
      recallSdkStateAtStart: metadata.recallSdkStateAtStart,
      recallPermissionsAtStart: metadata.recallPermissionsAtStart,
    },
  });
};

const normalizeDesktopAudioCaptureDiagnosticsContext = ({
  captureDiagnosticsContext,
}: {
  captureDiagnosticsContext?: DesktopAudioCaptureDiagnosticsContext;
}): DesktopAudioCaptureDiagnosticsContext => {
  if (!captureDiagnosticsContext) {
    return {};
  }

  return objectModule.compactUndefined({
    recallSdkStateAtStart: captureDiagnosticsContext.recallSdkStateAtStart,
    recallPermissionsAtStart: filterDefinedPermissions({
      recallPermissionsAtStart: captureDiagnosticsContext.recallPermissionsAtStart,
    }),
  });
};

const filterDefinedPermissions = ({
  recallPermissionsAtStart,
}: {
  recallPermissionsAtStart?: RecallPermissionMap;
}): RecallPermissionMap | undefined => {
  if (!recallPermissionsAtStart) {
    return undefined;
  }

  const filtered = objectModule.compactUndefined(recallPermissionsAtStart);

  if (Object.keys(filtered).length === 0) {
    return undefined;
  }

  return filtered;
};
